export default {
  install (Vue) {
    let lastScrollY = 0
    Vue.prototype.$blockScroll = function (block) {
      if (block) lastScrollY = window.scrollY || window.pageYOffset
      document.body.style.position = block ? 'fixed' : 'relative'
      document.body.style.top = block ? `-${lastScrollY}px` : 'auto'

      if (!block) {
        window.scrollTo(0, lastScrollY)
        lastScrollY = 0
      }
    }
  }
}
